import { useEffect, useState } from "react";
import { FieldValues } from "react-hook-form";
import { useNavigate } from "react-router-dom";

import { useMerchantApiQuery } from "../../hooks";
import { IHookForm, IOnboardingStatus } from "../../interfaces-and-types";
import { View } from "./View";

export interface IOnboardingStepProps {
  isActive: boolean;
  handleNext: () => void;
  handlePrevious: () => void;
}

export interface IOnboardingStepViewProps<TFormValues extends FieldValues>
  extends IHookForm<TFormValues>,
    IOnboardingStepProps {}

export interface IOnboardingViewProps {
  step: number;
  stepsPerPage: number;
  totalSteps: number;
  handleNext: () => void;
  handlePrevious: () => void;
  handleComplete: () => void;
  handleCancel: () => void;
}

export const Onboarding = () => {
  const navigate = useNavigate();

  const {
    isLoading: isLoadingOnboardingStatus,
    isSuccess: isSuccessOnboardingStatus,
    data: onboardingStatus,
  } = useMerchantApiQuery<IOnboardingStatus>("getOnboardingStatus");

  const [step, setStep] = useState(1);

  // set step to last saved
  useEffect(() => {
    if (isSuccessOnboardingStatus) {
      const lastSavedStep = !onboardingStatus?.is_onboarding_step1_completed
        ? 1
        : !onboardingStatus?.is_onboarding_step2_completed
        ? 2
        : !onboardingStatus?.is_onboarding_step3_completed
        ? 3
        : !onboardingStatus?.is_onboarding_step4_completed
        ? 4
        : !onboardingStatus?.is_onboarding_step5_completed
        ? 5
        : 6;
      setStep(lastSavedStep);
    }
  }, [isSuccessOnboardingStatus]);

  const stepsPerPage = 3;
  const totalSteps = 6;

  const handleNext = () => {
    step < totalSteps && setStep(step + 1);
  };
  const handlePrevious = () => {
    step > 1 && setStep(step - 1);
  };
  const handleComplete = () => {
    navigate("/");
  };
  const handleCancel = () => {
    navigate("/");
  };

  return (
    <View
      step={step}
      stepsPerPage={stepsPerPage}
      totalSteps={totalSteps}
      handleNext={handleNext}
      handlePrevious={handlePrevious}
      handleComplete={handleComplete}
      handleCancel={handleCancel}
    />
  );
};
